<template>
  <div>
    <SmartTitle
      class="mb-4"
      weight="medium"
      heading="2"
    >
      Criar Relação de Distribuidores
    </SmartTitle>
    <SmartCard
      class="card"
      shadow="small"
      padding="5"
    >
      <div>
        <div>
          <SmartTitle
            class="mb-4"
            weight="medium"
            heading="2"
          >
            Nome dos Distribuidores
          </SmartTitle>
        </div>
        <div class="flex align-center">
          <div class="flex flex-col">
            <V-Select
              :items="distributorsListDe"
              item-value="id"
              item-text="name"
              label="Distribuidor de"
              placeholder="Selecione um Distribuidor"
              v-model="selectedDistributor"
            />
            <SmartInput
              @change="inputValues"
              class="date-pickers mr-2"
              label="Data Inicial / Data Final"
              type="date-picker"
              range
              confirm
              v-model="date"
            />
          </div>
          <div
            style="margin-bottom: 60px"
            class="flex flex-col"
          >
            <V-Select
              :disabled="!(!!selectedDistributor)"
              :items="distributorsListPara"
              item-value="id"
              item-text="name"
              label="Distribuidor para"
              placeholder="Selecione os Distribuidores"
              v-model="selectedDistributors"
              multiple
            >
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index === 0">
                  <span>{{ item.name }}</span>
                </v-chip>
                <span
                  v-if="index === 1"
                  class="grey--text caption"
                >+ (Outros)
                </span>
              </template>
            </V-Select>
          </div>
        </div>
      </div>
    </SmartCard>
    <div class="flex justify-end mt-4">
      <SmartButton
        quaternary
        @click="backToList"
        class="mr-3"
      >
        Cancelar
      </SmartButton>
      <SmartButton
        :loading="loading"
        @click="createDistributorsRelations"
        secondary>
        Salvar
      </SmartButton>
    </div>
    <v-snackbar
      v-model="snackbar"
      :bottom="y === 'bottom'"
      :color="color"
      :left="x === 'left'"
      :multi-line="mode === 'multi-line'"
      :right="x === 'right'"
      :timeout="timeout"
      :top="y === 'top'"
      :vertical="mode === 'vertical'"
    >
      {{ text }}
      <v-btn
        dark
        text
        @click="snackbar = false"
      >
        Fechar
      </v-btn>
    </v-snackbar>
    <SmartModal
      v-if="modal"
      v-bind="modal"
      @close="modal = null"
    >
      {{ modal.text }}
    </SmartModal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { formatUSDate } from 'utils/date';

export default {
  name: 'CreateDistributorsRelations',
  data() {
    return {
      date: [],
      initialDate: '',
      finalDate: '',
      distributorsCopy: [],
      selectedDistributor: '',
      selectedDistributors: [],
      loading: false,
      modal: null,
      color: '#77bd4f',
      mode: '',
      snackbar: false,
      text: 'Relação criada com sucesso!',
      timeout: 3000,
      x: null,
      y: 'bottom'
    };
  },
  watch: {
    selectedDistributor() {
      if (this.selectedDistributor > 0) {
        this.distributorsPara(this.selectedDistributor);
      }
    }
  },
  computed: {
    ...mapGetters({
      distributorsListDe: 'deParaFaturamento/distributors',
      distributorsListPara: 'deParaFaturamento/distributorsPara'
    })
  },
  methods: {
    ...mapActions({
      distributors: 'deParaFaturamento/fetchDistributors',
      distributorsPara: 'deParaFaturamento/fetchDistributorsPara',
      save: 'deParaFaturamento/save'
    }),
    showModal(modalObj) {
      this.modal = {
        type: modalObj.type,
        title: modalObj.title,
        icon: modalObj.icon,
        buttonText: modalObj.buttonText,
        secondButton: modalObj.secondButton,
        text: modalObj.text
      };
    },
    createDistributorsRelations() {
      this.loading = true;
      this.save({ db_from_to: this.createPayload() })
        .then(() => {
          this.snackbar = true;

          setTimeout(() => {
            this.clearFields();
            this.$router.push({ name: 'DeParaFaturamento' });
          }, 3500);
          this.snackbar = true;
        })
        .catch(({ data }) => {
          const msg = (data.errors) ? data.errors[0].message : data.message;
          this.showModal({
            type: 'warning',
            title: 'Ops! Algo deu errado.',
            icon: 'alert',
            buttonText: 'Ok',
            text: msg
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    inputValues() {
      this.initialDate = formatUSDate(this.date[0]);
      this.finalDate = formatUSDate(this.date[1]);
    },
    clearFields() {
      this.initialDate = null;
      this.finalDate = null;
      this.selectedDistributor = null;
      this.selectedDistributors = null;
    },
    createPayload() {
      const dbFromTo = [];
      this.inputValues();
      this.selectedDistributors.forEach((db) => {
        const obj = {
          db_id_from: this.selectedDistributor,
          db_id_to: db,
          date_start: formatUSDate(this.initialDate),
          date_end: formatUSDate(this.finalDate)
        };
        dbFromTo.push(obj);
      });
      return dbFromTo;
    },
    backToList() {
      this.$router.push({ name: 'DeParaFaturamento' });
    }
  },
  mounted() {
    this.distributors();
  }
};
</script>

<style scoped>

.card {
  padding: 2rem 2rem 2rem;
}
</style>
